$s.validateMarketInJson = async function (items, marketHandle) {
  if (!marketHandle) return;

  const checkIsValidMarket = (properties, marketHandle) => {
    const { _market: itemMarketHandle } = properties;
    return itemMarketHandle == marketHandle;
  }

  const updates = items
    .map(item => item.properties && Object.hasOwn(item.properties, '_market') ? item : { ...item, properties: { ...item.properties, _market: '' }})
    .filter(item => !checkIsValidMarket(item.properties, marketHandle))
    .map(item => ({ key: item.key, quantity: 0 }))

  if (updates.length == 0) return;

  var dataUpdate = { updates: {} };
  updates.forEach(update => dataUpdate.updates[update.key] = update.quantity)

  try {
    await $s.updateCartItemsQuantity(dataUpdate);
    $s.hideLoadingOverlay();
    const overlayHtml = `<div class="error-itemincart scheme">${lngg.cart__markets__removed_items}</div>`
    if (window.SideCart) {
      window.SideCart.updateSideCart(false)
      $s.openModal(overlayHtml, 'message');
    } else {
      $s.openModal(overlayHtml, 'message', {
        close: () => {
          window.location.reload()
        }
      });
    }
  } catch (error) {
    $s.addToCartFail
  }
}
